import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

function Header() {
    const [isSticky, setIsSticky] = useState(false);
    const [isHeaderOpen, setIsHeaderOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Check if the page is scrolled down more than 50px
            if (window.scrollY > 50) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        // Add scroll event listener
        window.addEventListener("scroll", handleScroll);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const toggleHeader = () => {
        setIsHeaderOpen((prev) => !prev);
    };

    return (
        <>
            {/* Header Section Start */}
            <header className={`header-wrap style1 ${isSticky ? "sticky" : ""}`}>
            <div className={`header-top ${isHeaderOpen ? "open" : ""}`}>
                    <div className="close-header-top xl-none">
                    <button type="button" onClick={() => setIsHeaderOpen(false)}>
                            <i className="las la-times" />
                        </button>
                    </div>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-8 col-lg-12">
                                <div id="menu" className="d-block d-sm-none mb-5">
                                    <ul className="main-menu list-style">
                                        <li>
                                            <NavLink to="/money-transfer" onClick={() => setIsHeaderOpen(false)}>
                                                Transfer Money to Nigeria
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/general-faq" onClick={() => setIsHeaderOpen(false)}>
                                                FAQ's
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/contact-us" onClick={() => setIsHeaderOpen(false)}>
                                                Contact Us
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/help" onClick={() => setIsHeaderOpen(false)}>Help</NavLink>
                                        </li>
                                    </ul>
                                </div>
                                <div className="header-top-left">
                                    <div className="contact-item">
                                        <i className="flaticon-call-1" />
                                        <NavLink to="tel:447852538754">
                                            +44 785 253 8754
                                        </NavLink>
                                    </div>
                                    <div className="contact-item">
                                        <i className="flaticon-email" />
                                        <NavLink to="mailto:info@finestpay.co.uk">
                                            info@finestpay.co.uk
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-12">
                                <div className="header-top-right">
                                    <ul className="social-profile style2 list-style">
                                        <li>
                                            <NavLink target="_blank" to="https://facebook.com/">
                                                <i className="flaticon-facebook-app-symbol" />
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink target="_blank" to="https://twitter.com/">
                                                <i className="flaticon-twitter" />
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink target="_blank" to="https://instagram.com/">
                                                <i className="flaticon-instagram-2" />
                                            </NavLink>
                                        </li>
                                    </ul>
                                    <div className="xl-none d-flex">
                                        <NavLink
                                            to="https://finestpay.co.uk/app/app-register.html"
                                            className="btn style1"
                                            target="_blank"
                                        >
                                            Sign Up
                                        </NavLink>&nbsp;
                                        <NavLink
                                            to="https://finestpay.co.uk/app/"
                                            className="btn style1"
                                            target="_blank"
                                        >
                                            Login
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header-bottom">
                    <div className="container">
                        <div className="header-bottom-wrap">
                            <div className="row align-items-center">
                                <div className="col-xl-3 col-lg-6 col-md-6 col-5">
                                    <NavLink to="/" className="logo">
                                        <img
                                            className="logo-light"
                                            src="assets/img/logo.svg"
                                            alt="Image"
                                        />
                                    </NavLink>
                                </div>
                                <div className="col-xl-5 col-lg-5 col-md-5 col-7">
                                    <div className="main-menu-wrap">
                                        <div className="menu-close xl-none">
                                            <NavLink to="#">
                                                <i className="las la-times" />
                                            </NavLink>
                                        </div>
                                        <div id="menu">
                                            <ul className="main-menu list-style">
                                                <li>
                                                    <NavLink to="/money-transfer">
                                                        Transfer Money to Nigeria
                                                    </NavLink>
                                                </li>
                                                <li>
                                                    <NavLink to="/general-faq">
                                                        FAQ's
                                                    </NavLink>
                                                </li>
                                                <li>
                                                    <NavLink to="/contact-us">
                                                        Contact Us
                                                    </NavLink>
                                                </li>
                                                <li>
                                                    <NavLink to="/help">Help</NavLink>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="mobile-bar-wrap">
                                        <div className="mobile-menu xl-none">
                                        <NavLink to="#" onClick={toggleHeader}>
                                                <i className="las la-bars" />
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 lg-none">
                                    <div className="header-bottom-right">
                                        <NavLink
                                            to="https://finestpay.co.uk/app/app-register.html"
                                            className="btn style1"
                                            target="_blank"
                                        >
                                            Sign Up
                                        </NavLink>
                                        <NavLink
                                            to="https://finestpay.co.uk/app/"
                                            className="btn style1"
                                            target="_blank"
                                        >
                                            Login
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {/* Header Section End */}
        </>
    );
}

export default Header;
